import { Mail, CheckCircle2, CalendarClock } from "lucide-react";
import { Button } from "../ui/button";
import Reveal from "../Reveal";

const EMAIL = "info@fyzeron.com";

export default function Contact() {
  return (
    <section id="contact" data-testid="contact-section" className="relative py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-stretch">
          {/* Book a demo (left) */}
          <Reveal>
            <div id="demo-form" className="h-full rounded-3xl bg-navy text-white p-8 lg:p-10 grain relative overflow-hidden">
              <div className="absolute -top-20 -right-20 h-72 w-72 rounded-full bg-blue-800/15 blur-3xl" />
              <p className="text-xs font-bold uppercase tracking-[0.2em] text-blue-700">Book a demo</p>
              <h3 className="font-display font-black text-3xl sm:text-4xl tracking-tight mt-3">
                See FolioStax in 15 minutes.
              </h3>
              <p className="mt-3 text-slate-300">
                A quick walkthrough of billing, inventory and reports — tailored to how your shop runs.
                No credit card, no commitments.
              </p>
              <ul className="mt-6 space-y-3 text-sm text-slate-200">
                {[
                  "Live screen-share or in-person",
                  "Setup guidance for your business type",
                  "Straight answers on pricing & migration",
                ].map((t) => (
                  <li key={t} className="flex items-start gap-3">
                    <CheckCircle2 className="h-5 w-5 text-blue-700 shrink-0" /> {t}
                  </li>
                ))}
              </ul>
              <a href={`mailto:${EMAIL}?subject=FolioStax%20demo%20request`}>
                <Button
                  data-testid="demo-submit"
                  className="mt-8 w-full rounded-full bg-blue-800 hover:bg-blue-700 text-white py-6 font-semibold"
                >
                  Request a demo
                </Button>
              </a>
            </div>
          </Reveal>

          {/* Contact details (right) */}
          <Reveal delay={120}>
            <div className="h-full flex flex-col">
              <p className="text-xs font-bold uppercase tracking-[0.2em] text-blue-800">Get in touch</p>
              <h3 className="font-display font-black text-3xl sm:text-4xl tracking-tight text-slate-900 mt-3">
                Talk to a real human.
              </h3>
              <p className="mt-3 text-slate-600">
                Sales, support or partnerships — email us and we'll reply within one business day.
              </p>

              <a
                href={`mailto:${EMAIL}`}
                data-testid="contact-email"
                className="mt-8 rounded-2xl border border-slate-200 bg-white p-6 hover:border-blue-600 hover:shadow-sm transition group flex items-start gap-4"
              >
                <div className="h-12 w-12 rounded-xl bg-navy grid place-items-center shrink-0 group-hover:bg-blue-800 transition">
                  <Mail className="h-5 w-5 text-blue-700 group-hover:text-white transition" />
                </div>
                <div>
                  <p className="text-[11px] font-bold uppercase tracking-wider text-slate-500">Email</p>
                  <p className="text-lg font-semibold text-slate-900 mt-0.5">{EMAIL}</p>
                  <p className="text-sm text-slate-500 mt-1">
                    Prefer a callback? Include your number and we'll ring you.
                  </p>
                </div>
              </a>

              <div className="mt-6 rounded-2xl bg-slate-50 border border-slate-200 p-6 flex items-start gap-4">
                <CalendarClock className="h-5 w-5 text-blue-800 shrink-0 mt-0.5" />
                <p className="text-sm text-slate-600">
                  <span className="font-semibold text-slate-900">Early access.</span> FolioStax is rolling out to
                  its first businesses. Email us to join the early list and we'll help you get set up.
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
